import request from '@/utils/request'

const Api = '/api/chatbot/bigdata'

export function realtimeOverview (params) {
  return request({
    url: '/api/chatbot/dashboard/realtime-overview',
    method: 'get',
    params
  })
}

export function realtimeSessionReport (params) {
  return request({
    url: '/api/chatbot/dashboard/realtime-sessionReport',
    method: 'get',
    params
  })
}

export function realtimeTimeReport (params) {
  return request({
    url: '/api/chatbot/dashboard/realtime-timeReport',
    method: 'get',
    params
  })
}

export function realtimeServiceValid (params) {
  return request({
    url: '/api/chatbot/dashboard/realtime-serviceValid',
    method: 'get',
    params
  })
}

export function realtimeReason (params) {
  return request({
    url: '/api/chatbot/dashboard/realtime-reason_type',
    method: 'get',
    params
  })
}

export function offlineServiceValid (params) {
  return request({
    url: '/api/chatbot/dashboard/offline-serviceValid',
    method: 'get',
    params
  })
}

export function offlineReason (params) {
  return request({
    url: Api + '/chatbot/offline/reason_old',
    method: 'post',
    data: params
  })
}

export function offlineOverview (params) {
  return request({
    url: '/api/chatbot/dashboard/offline-overview',
    method: 'get',
    params
  })
}

export function offlineCoredate(params) {
  return request({
    url: '/api/chatbot/dashboard/offline-coredata',
    method: 'get',
    params
  })
}

export function offlineCsat(params) {
  return request({
    url: '/api/chatbot/dashboard/offline-csat?',
    method: 'get',
    params
  })
}

export function offlineSessioncloseinfo(params) {
  return request({
    url: '/api/chatbot/dashboard/offline-sessioncloseinfo',
    method: 'get',
    params
  })
}

export function offlineDownloadInfo(params) {
  return request({
    url: '/api/chatbot/dashboard/offline-downloadinfo',
    method: 'get',
    params
  })
}

export function offlineGeneralityDownloadInfo(data) {
  return request({
    url: Api + '/chatbot/generality/offline/downloadinfo',
    method: 'post',
    data
  })
}

export function getCountrys() {
  return request({
    url: `/api/chatbot/dashboard/offline-country`,
    method: 'get'
  })
}

export function robotOverview(params) {
  return request({
    url: '/api/chatbot/dashboard/robot-overview',
    method: 'get',
    params
  })
}

export function robotInfo(params) {
  return request({
    url: '/api/chatbot/dashboard/robot-robotinfo',
    method: 'get',
    params
  })
}

export function robotSessioncloseinfo(params) {
  return request({
    url: '/api/chatbot/dashboard/robot-robotsessioncloseinfo',
    method: 'get',
    params
  })
}

export function robotknowledge(params) {
  return request({
    url: '/api/chatbot/dashboard/robot-robotknowledge',
    method: 'get',
    params
  })
}

export function authList() {
  return request({
    url: '/api/chatbot/auth/list',
    method: 'get'
  })
}

export function bindRobot(id, data) {
  return request({
    url: `/api/chatbot/auth/bind/${id}`,
    method: 'post',
    data
  })
}

export function bindRecord(id) {
  return request({
    url: `/api/chatbot/auth/bind/${id}`,
    method: 'get'
  })
}

export function auth(type, data) {
  return request({
    url: `/api/chatbot/auth/${type}`,
    method: 'post',
    data
  })
}

export function cancelAuth(id) {
  return request({
    url: `/api/chatbot/auth/cancel/${id}`,
    method: 'post'
  })
}

export function authConfigs() {
  return request({
    url: '/api/chatbot/auth/configs',
    method: 'get'
  })
}

export function addAuthConfig(data) {
  return request({
    url: '/api/chatbot/auth/config/add',
    method: 'post',
    data
  })
}

export function editAuthConfig(id, data) {
  return request({
    url: `/api/chatbot/auth/config/edit/${id}`,
    method: 'post',
    data
  })
}

export function delAuthConfig(id, data) {
  return request({
    url: `/api/chatbot/auth/config/del/${id}`,
    method: 'post',
    data
  })
}

export function templateList(data) {
  return request({
    url: '/api/chatbot/omnichannel/template/list',
    method: 'post',
    data
  })
}

export function templateDetail(id, params) {
  return request({
    url: `/api/chatbot/omnichannel/template/${id}`,
    method: 'get',
    params
  })
}

export function createTemplate(data) {
  return request({
    url: '/api/chatbot/omnichannel/template',
    method: 'post',
    data
  })
}

export function editTemplate(data) {
  return request({
    url: '/api/chatbot/omnichannel/template/edit',
    method: 'post',
    data
  })
}

export function delTemplate(data) {
  return request({
    url: '/api/chatbot/omnichannel/template/del',
    method: 'post',
    data
  })
}

export function upload(data) {
  const reqObj = new FormData()
  Object.keys(data).forEach(key => {
    reqObj.append(key, data[key])
  })
  return request({
    url: '/api/chatbot/common/upload',
    method: 'post',
    data: reqObj,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getCommonChannels() {
  return request({
    url: '/api/chatbot/common/channels',
    method: 'get'
  })
}

export function getcCannelInf(params) {
  return request({
    url: '/api/chatbot/common/channel/info',
    method: 'get',
    params
  })
}

export function getBroadcastList(data) {
  return request({
    url: '/api/chatbot/broadcast/list',
    method: 'post',
    data
  })
}

export function cancelBroadcast(id) {
  return request({
    url: `/api/chatbot/broadcast/cancel/${id}`,
    method: 'post'
  })
}

export function createBroadcast(data) {
  return request({
    url: '/api/chatbot/broadcast',
    method: 'post',
    data
  })
}

export function broadcastDetail(id, params) {
  return request({
    url: `/api/chatbot/broadcast/${id}`,
    method: 'get',
    params
  })
}

export function callRecord(data) {
  return request({
    url: '/api/chatbot/callrecord',
    method: 'post',
    data
  })
}

export function sessionDetaill(data) {
  return request({
    url: '/api/chatbot/bigdata/chatbot/session/sessiondetail',
    method: 'post',
    data
  })
}

export function optOutList(data) {
  return request({
    url: '/api/chatbot/optout/list',
    method: 'post',
    data
  })
}

export function optOutBatch(data) {
  return request({
    url: '/api/chatbot/optout/batch',
    method: 'post',
    data
  })
}

export function optOutCancel(data) {
  return request({
    url: '/api/chatbot/optout/cancel',
    method: 'post',
    data
  })
}

export function optOutDetail(data) {
  return request({
    url: '/api/chatbot/optout/detail',
    method: 'post',
    data
  })
}

export function generalitySessionDetaill(data) {
  return request({
    url: '/api/chatbot/bigdata/chatbot/generality/conversation/sessiondetail',
    method: 'post',
    data
  })
}

export function generalityCallRecord(data) {
  return request({
    url: '/api/chatbot/common/dashboard/callrecord',
    method: 'post',
    data
  })
}

export function getHoursessioninfov2 (data) {
  return request({
    url: Api + '/chatbot/offline/hoursessioninfov2',
    method: 'post',
    data
  })
}

export function getOfflineHoursessioninfov2 (data) {
  return request({
    url: Api + '/chatbot/generality/offline/data_overview/hoursessioninfov2',
    method: 'post',
    data
  })
}

export function historicalLinechart (data) {
  return request({
    url: Api + '/chatbot/offline/linechartv2',
    method: 'post',
    data
  })
}

export function getOfflineHistoricalLinechart (data) {
  return request({
    url: Api + '/chatbot/generality/offline/data_overview/linechartv2',
    method: 'post',
    data
  })
}

export function getServiceValid (data) {
  return request({
    url: Api + '/chatbot/offline/serviceValid',
    method: 'post',
    data
  })
}

export function getServiceValid2 (data) {
  return request({
    url: Api + '/chatbot/offline/serviceresultV2',
    method: 'post',
    data
  })
}

export function getReason (data) {
  return request({
    url: Api + '/chatbot/offline/reason',
    method: 'post',
    data
  })
}

export function getCsatdata (data) {
  return request({
    url: Api + '/chatbot/offline/csat',
    method: 'post',
    data
  })
}

export function getTickettype (data) {
  return request({
    url: Api + '/chatbot/offline/tickettypeV2',
    method: 'post',
    data
  })
}

export function getFalseSignature (data) {
  return request({
    url: Api + '/chatbot/offline/false_signature',
    method: 'post',
    data
  })
}

export function getWABADatas (data) {
  return request({
    url: 'api/chatbot/bigdata/chatbot/offline/wabatypebills',
    method: 'post',
    data
  })
}

export function getJTConfig (user_id, edit_from) {
  return request({
    url: 'api/chatbot/jt/dashboard/user_config',
    method: 'get',
    params: {
      user_id,
      edit_from
    }
  })
}

export function setJTConfig (params) {
  return request({
    url: 'api/chatbot/jt/dashboard/user_config',
    method: 'post',
    data: params
  })
}

export function getOfflineRobotStorytype (data) {
  return request({
    url: '/api/chatbot/common/dashboard/robot/story_type',
    method: 'post',
    data
  })
}

export function getOfflineRobotIntentionType (data) {
  return request({
    url: '/api/chatbot/common/dashboard/robot/robot_intention_type',
    method: 'post',
    data
  })
}

export function getOfflineRobotTransferReasonType (data) {
  return request({
    url: '/api/chatbot/common/dashboard/robot/transfer_reason_type',
    method: 'post',
    data
  })
}

export function getTopKnowledge (data) {
  return request({
    url: '/api/chatbot/common/dashboard/top_knowledge',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/chatbot.js